import React from 'react';
import EventBus from '../../utils/EventBus';
import Icon from '../ui/Icon';
import styles from './Topbar.module.css';

const PAGE_TITLES = {
  '/':          'Dashboard',
  '/analytics': 'Analytics',
  '/campaigns': 'Campaigns',
  '/journeys':  'Journeys',
  '/segments':  'Segments',
  '/abtests':   'A/B Tests',
  '/push':      'Push Notifications',
  '/inapp':     'In-App Messages',
  '/whatsapp':  'WhatsApp',
  '/events':    'Events',
  '/settings':  'Settings',
};

class Topbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { search: '', liveCnt: '2,184' };
    this.handleNewCampaign = this.handleNewCampaign.bind(this);
  }

  handleNewCampaign() {
    EventBus.emit('openWizard', {});
  }

  render() {
    const { pathname = '/', themeName, toggleTheme, onLogout } = this.props;
    const title = PAGE_TITLES[pathname] || 'PMW Click';

    return (
      <header className={styles.topbar}>
        <span className={styles.title}>{title}</span>

        <div className={styles.searchBox}>
          <span className={styles.searchIcon}><Icon name="search" size={16} /></span>
          <input
            className={styles.searchInput}
            placeholder="Search users, events, campaigns…"
            value={this.state.search}
            onChange={e => this.setState({ search: e.target.value })}
          />
        </div>

        <div className={styles.space} />

        <div className={styles.livePill}>
          <div className={styles.pulse} />
          <span>{this.state.liveCnt}</span>
          &nbsp;live
        </div>

        <button className={styles.tbBtn}>
          <Icon name="calendar_month" size={14} /> Jun 2026
        </button>

        <button className={styles.tbBtn + ' ' + styles.pri} onClick={this.handleNewCampaign}>
          + New Campaign
        </button>

        <button
          className={styles.themeBtn}
          onClick={toggleTheme}
          title={themeName === 'dark' ? 'Switch to light' : 'Switch to dark'}
        >
          <Icon name={themeName === 'dark' ? 'light_mode' : 'dark_mode'} size={18} />
        </button>

        <div className={styles.notifBtn}>
          <Icon name="notifications" size={18} />
          <span className={styles.notifDot} />
        </div>

        <button className={styles.themeBtn} onClick={onLogout} title="Log out">
          <Icon name="logout" size={18} />
        </button>
      </header>
    );
  }
}

export default Topbar;
